// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1zFxe","content":"styles_content__3TwPA","checkbox":"styles_checkbox__3HQSc","checkboxLabel":"styles_checkboxLabel__1t0JN"};